import { render, staticRenderFns } from "./TasksOverview.vue?vue&type=template&id=403a425b"
import script from "./TasksOverview.vue?vue&type=script&lang=js"
export * from "./TasksOverview.vue?vue&type=script&lang=js"
import style0 from "./TasksOverview.vue?vue&type=style&index=0&id=403a425b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports